import { Button, createStyles, makeStyles, Theme } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import chatApi from '../../api/chatApi'
import { getMedicineNameStage, getTestingstageTaskOnTask, TestingStage } from '../../api/chatApi/chatApi'
import CustomButton from '../../components/common/CustomButton'
import TooltipDialog from '../../components/common/TooltipDialog'
import MainLayout from '../../components/Layout/MainLayout'
import DiagnosisTooltip from '../../components/Tooltips/DiagnosisTooltip'
import useTooltipState from '../../hooks/useTooltipState'
import useTestingStage from '../../hooks/testingTask/useTestingStage'
import useIncreaseTaskStage from '../../hooks/testingTask/useIncreaseTaskStage'
import { RoutePath } from '../../types'
import RatingDialog from '../../components/Chat/RatingDialog'
import Model from '../../3d_model/Model'
import { Link } from 'react-router-dom'
import TestModelTooltip from '../../components/Tooltips/TestModelTooltip'
import TooltipAccordion from '../../components/TooltipAccordion'
import ChatTooltip from '../../components/Tooltips/ChatTooltip'

interface TooltipData {
  testingstage_id: number;
  name: string;
  job_hint: string;
  stage_hint: string;
  stage_hint_name: string;
  stage_hint_blue: string;
}

interface Stage {
  testingstage_id: number;
  name: string;
  routePath: string;
  routhPathCode: string;
  activeStage: number;
  code: string;
  legend_id?: number;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      maxWidth: '97%',
      margin: '0 auto',
      color: theme.palette.text.secondary
      // backgroundColor: theme.palette.background.paper,
    },
    model: {
      position: 'relative',
      padding: '20px 0 0 0',
      minWidth: '100%',
      minHeight: '87vh',
      overflow: 'hidden'
    },
    title: {
      textAlign: 'center'
    }
  })
)

export default function TestModel() {
  // const stage = 0
  const stage = useTestingStage();
  const [increaseLoading, increase] = useIncreaseTaskStage(RoutePath.chat)

  const classes = useStyles()
  const [tooltipState, openTooltip] = useTooltipState()
  const [open, setOpen] = React.useState(true)
  const [openRating, setOpenRating] = React.useState(false)
  const testingStage = useTestingStage()


  const [status, setStatus] = useState<boolean>(false)
  useEffect(() => {
    const getDialogStatus = async () => {
      try {
        const response = await chatApi.getSettingsPiloting();
        const statusValue = response?.result?.[0]?.value;
        setStatus(statusValue === 'true');
      } catch (error) {
        console.log('Не удалось получить настройки пилотинга', error)
        setStatus(false)
      }
    };

    void getDialogStatus();
  }, []);



  function hideRatingDialog() {
    // increase()
    setOpen(false)
  }

  const patientModel = useQuery(
    'patientModel',
    async () => {
      const currTask: any = await chatApi.unfinishedTask()
      return currTask?.result?.task?.patientModel?.view3dLink
    },
    { refetchOnMount: true }
  )

  const view3dLink = async () => {
    const currTask: any = await chatApi.unfinishedTask()
    setLink(currTask?.result?.task?.patientModel?.view3dLink)
  }
  const [link, setLink] = useState('')

  useEffect(() => {
    view3dLink()
  }, []);

  const taskName = '8'

  useEffect(() => {
    getMedicineNameStages()
  }, [])

  const [tooltipText, setTootipText] = useState<TooltipData | null>(null)

  async function getMedicineNameStages() {
    try {
      const result = await getMedicineNameStage({ task_id: taskId })

      if (result.data.MedicineNameStage && result.data.MedicineNameStage.length > 0) {
        const stageHintElement = result.data.MedicineNameStage.find(el => el.testingstage_id === testingStage)
        setTootipText(stageHintElement)
      }

    } catch (error) {
      console.log(error)
    }
  }

  const [taskId, setTaskId] = useState<number>(0)
  const [taskTaskProceedId, setTaskTaskProceedId] = useState<number>(0)

  async function unfinishedTaskHandler() {
    try {
      const response = await chatApi.unfinishedTask()
      setTaskId(response.result.taskId)
      setTaskTaskProceedId(response.result.id)
    } catch (err) {
      console.log('при выполнении unfinishedTaskHandler', err);
    }
  }

  useEffect(() => {
    unfinishedTaskHandler()
  }, [])

  const [currentStage, setCurrentStage] = useState<Stage | null>(null)


  async function fetchAllStages() {
    try {
      const result = await getTestingstageTaskOnTask();
      const currentStage = result.data.testingstage_task_on_task.find((stage: Stage) => stage.routePath === '/testModel');
      setCurrentStage(currentStage);
    } catch (error) {
      console.error('Ошибка при загрузке этапов:', error);
    }
  }

  useEffect(() => {
    fetchAllStages()
  }, [])

  const [medicineNameStage, setMedicineNameStage] = useState<string>('')

  async function getNameStage() {
    if (!taskId || !currentStage) {
      return
    }
    
    try {
      const result = await getMedicineNameStage({ task_id: taskId })
      
      if (result?.data?.MedicineNameStage) {
        const matchingStage = result.data.MedicineNameStage.find((item: any) => 
          item.testingstage_id === currentStage.testingstage_id
        )
        const stageName = matchingStage?.name
        setMedicineNameStage(stageName || '')
      } else {
        setMedicineNameStage('')
      }
    } catch (error) {
      console.error('Error fetching stage name:', error)
      setMedicineNameStage('')
    }
  }

  useEffect(() => {
    getNameStage()
  }, [taskId, currentStage])




  return (
    <MainLayout title={medicineNameStage || 'Пациент'} onClickTooltip={openTooltip}>
      {openRating ? (
        <RatingDialog open={openRating} onSubmit={hideRatingDialog} />
      ) : null}

      <TooltipDialog {...tooltipState}>
        {tooltipText ? <ChatTooltip task_id={taskId} testingStageId={testingStage} /> : <TestModelTooltip />}
      </TooltipDialog>
      {currentStage && <TooltipAccordion taskName={taskName} taskId={taskId} currentStage={currentStage} />}

      <div
        className={classes.root}
        style={{ height: `85vh`, width: `100%`, position: `relative`, overflow: 'hidden', marginTop: 30 }}
      >

        {open && link ? (
          <div>
            <Model type={link} embedded={false} taskTaskProceedId={taskTaskProceedId} />
          </div>
        ) : (
          <>

          </>
        )}
      </div>
    </MainLayout>
  )
}
